export enum IAccessTypes {
  K8S_API = 'K8S_API',
  BASTION = 'BASTION',
  AWS_ROLE = 'AWS_ROLE',
  HOST = 'HOST',
  MS_ENTRA_ID_GROUP = 'MS_ENTRA_ID_GROUP',
}

export enum IDeprecatedAccessTypes {
  SERVER = 'SERVER',
  ROLE = 'ROLE',
}

export default IAccessTypes;
